import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { escapeHtml } from '../../../../utils/textFunctions'
import '../../../../styles/assets/css/pages/form1.css'
import { loadLocationWithMessage } from '../../../../actions/location'
import GetPDF from '../../../functions/get_pdf.jsx'

class RoiPDF extends Component {
  constructor() {
      super()
      //var [fields, setFields] = useState([{ value: null }])
      this.state = {
          status: false,
          pdf: '',
          roi_list: [],
      }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/patient/get_roi_list',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.match.params.pid,
      }
    })
    .then((result) => {
      this.setState({
        roi_list: Array.isArray(result.data) ? result.data : [],
      })
    })
  }

  downloadPDF = (e, pdf) => {
    const linkSource = `data:application/pdf;base64,${pdf}`
    const downloadLink = document.createElement("a")
    const fileName = "download_"+Date.now()+".pdf"
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.target = "_blank"
    //downloadLink.setAttribute('target', '_blank')
    downloadLink.click()
  }

  render() {
    return (
      <div className="row roi_pdf">
        <div className="small-12 columns">
          <GetPDF path="roi_pdf"  />
        </div>
        <hr />
        <div className="small-12 columns">
        {this.state.roi_list.map((each, i) =>
          <div className="row">
            <div className="small-12 columns bold">
              ROI Version {each.roi_version} : <a href={'/admin/consent/roi/'+each.roi_version+'/'+this.props.match.params.pid} target="_blank">Download</a>
              {i == 0 && ' (Latest)'}
            </div>
          </div>
        )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
}

const mapDispatchToProps = (dispatch) => ({

})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(RoiPDF)
